import React, {useCallback} from "react";
import {Checkbox, SpinButton} from "@fluentui/react";

import type DrillholesCodeModalInputFieldProps from "./DrillholesCodeModalInputFieldProps";

import styles from "../../../calculationConstructionNewField.module.scss";

const DrillholesCodeModalInputField: React.FunctionComponent<DrillholesCodeModalInputFieldProps> = ({
    uiDrillhole,
    isDrillholeMatched,
    drillholeEditDto,
    onToggle,
    onNumberChange,
}) => {
  const handleCheckboxChange = useCallback(
    (isChecked?: boolean): void => {
      if (isChecked === null || isChecked === undefined) {
        return;
      }
      onToggle(isChecked);
    },
    [onToggle],
  );

  const handleSpinnerButtonChange = useCallback(
    (newValue?: string): void => {
      if (newValue === undefined) {
        return;
      }

      const parsingResult = parseInt(newValue, 10);
      if (isNaN(parsingResult)) {
        return;
      }

      onNumberChange(parsingResult);
    },
    [onNumberChange],
  );

  return (
    <>
      <div className={styles.drillholesCodeModalCheckbox}>
        <Checkbox
          label={uiDrillhole.symbol}
          checked={isDrillholeMatched}
          onChange={(_, check) => {
            handleCheckboxChange(check);
          }}></Checkbox>
      </div>
      {uiDrillhole.hasIndex && (
        <SpinButton
          min={0}
          step={1}
          max={100}
          disabled={!isDrillholeMatched}
          value={drillholeEditDto?.number?.toString() ?? "0"}
          onChange={(_, newValue) => {
            handleSpinnerButtonChange(newValue);
          }}
        />
      )}
    </>
  );
};

export default DrillholesCodeModalInputField;
